export enum CohortClassStatus {
  PENDIENTE = 'PENDIENTE',
  EN_CURSO = 'EN_CURSO',
  FINALIZADA = 'FINALIZADA',
  POSTERGADA = 'POSTERGADA',
  ON_DEMAND = 'ON_DEMAND',
}
